import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonColorUtils from "../../../utils/common_colors";
import {useState, useEffect} from "react";
import {
    CommonPhoneNumberTextField,
    CommonEmailTextField,
} from "../../../components/commonTextField";
import {ArrowDropUp, ArrowDropDown} from "@mui/icons-material";
import {FullButton} from "../../../components/button/common_button";
import DriverDropdown from "./driver_dropdown";
import {showErrorToast} from "../../../components/toast/error_toast";
import {showSuccessToast} from "../../../components/toast/success_toast";
import {locationUpdateApiCall} from "../../controllers/location_repository_controller";
import {createDriverLocationMapping} from "../../controllers/location_repository_controller";

export function LocationDetailsDialog({
                                          isDialogOpen,
                                          handleCloseDialog,
                                          locationDetails,
                                          driverlist,
                                          driverName,
                                          driverUid,
                                      }) {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const [phoneNumber, setPhoneNumber] = useState(locationDetails?.phoneNumber);
    const [email, setEmail] = useState(locationDetails?.email);
    const [hour, setHour] = useState(0);
    const [min, setMin] = useState(0);
    const [amPmText, setAmPmText] = useState("AM");
    const [isButtonEnabled, setButtonEnabled] = useState(false);
    const [selectedDriverName, setSelectedDriverName] = useState("");
    const [selectedDriverUid, setSelectedDriverUid] = useState("");

    const [isEveryThingField, setEveryThingField] = useState({
        isPhoneNumberValid: true,
        isEmailValid: true,
        isHourValid: true,
        isMinuteValid: true,
    });

    useEffect(() => {
        setButtonEnabled(false);
        setPhoneNumber(locationDetails?.phoneNumber);
        setEmail(locationDetails?.email);
        if (!locationDetails?.pickupTime) {
            setHour(0);
            setMin(0);
            setAmPmText("AM");
        } else {
            let [hours, min] = locationDetails?.pickupTime.split(":");
            let hour = parseInt(hours);
            let amOrPm = hour < 12 ? "AM" : "PM";
            let stringHour;
            if (hour === 12 && amOrPm === "PM") {
                stringHour = `${hour}`;
            } else {
                stringHour = `${hour % 12}`;
            }

            if (stringHour < 10) {
                stringHour = `0${stringHour}`; /// if the hour value
            }

            setHour(stringHour);
            setMin(min);
            setAmPmText(amOrPm);
        }
        setSelectedDriverName(driverName);
        setSelectedDriverUid(driverUid);
        if (!phoneNumber && !email) {
            setButtonEnabled(true);
        }
    }, [
        locationDetails?.phoneNumber,
        locationDetails?.email,
        locationDetails?.pickupTime,
        driverName,
        driverUid,
    ]);

    useEffect(() => {
        const allValid = Object.values(isEveryThingField).every(
            (isValid) => isValid
        );

        setButtonEnabled(allValid);
    }, [isEveryThingField]);

    function phoneNumberValidation(inputValue) {
        if (inputValue.trim() === "") {
            return {isValid: false, message: "Phone number is required."};
        } else if (inputValue.length < 8) {
            return {
                isValid: false,
                message: "Phone number should have 8 digits.",
            };
        } else {
            return {
                isValid: true,
            };
        }
    }

    function emailValidation(inputValue) {
        if (inputValue.trim() === "") {
            return {isValid: false, message: "Please enter email"};
        } else if (!emailRegex.test(inputValue)) {
            return {
                isValid: false,
                message: "Invalid Email",
            };
        } else {
            return {
                isValid: true,
            };
        }
    }

    const handlePhoneNumberChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d*$/.test(changedValue)) {
            setPhoneNumber(changedValue);
            if (changedValue.trim() === "" || changedValue.length < 8) {
                setEveryThingField((previous) => ({
                    ...previous,
                    isPhoneNumberValid: false,
                }));
            } else {
                setEveryThingField((previous) => ({
                    ...previous,
                    isPhoneNumberValid: true,
                }));
            }
        }
    };

    const handleEmailChange = (e) => {
        const changedValue = e.target.value;
        setEmail(e.target.value);
        if (changedValue.trim() === "" || !emailRegex.test(changedValue)) {
            setEveryThingField((previous) => ({
                ...previous,
                isEmailValid: false,
            }));
        } else {
            setEveryThingField((previous) => ({
                ...previous,
                isEmailValid: true,
            }));
        }
    };

    const handleHourChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d{0,2}$/.test(changedValue)) {
            setHour(changedValue);
        }
        if (changedValue.trim() === "" || changedValue > 12) {
            setEveryThingField((previous) => ({
                ...previous,
                isHourValid: false,
            }));
        } else {
            setEveryThingField((previous) => ({
                ...previous,
                isHourValid: true,
            }));
        }
    };

    function validateHour(hourValue) {
        if (hourValue.trim() === "" || hourValue > 12) {
            return {isValid: false, message: "Invalid hour"};
        }
    }

    const handleMinChange = (e) => {
        const changedValue = e.target.value;
        if (/^\d{0,2}$/.test(changedValue)) {
            setMin(changedValue);
        }
        if (changedValue.trim() === "" || changedValue > 59) {
            setEveryThingField((previous) => ({
                ...previous,
                isMinuteValid: false,
            }));
        } else {
            setEveryThingField((previous) => ({
                ...previous,
                isMinuteValid: true,
            }));
        }
    };

    function validateMinute(minuteValue) {
        if (minuteValue.trim() === "" || minuteValue > 59) {
            return {isValid: false, message: "Invalid minute"};
        }
    }

    const handleArrowClick = () => {
        setAmPmText((previousValue) => (previousValue === "AM" ? "PM" : "AM"));
    };

    function handleDropdownChange(e) {
        const dropDownValue = e.target.value;
        driverlist.forEach((driver) => {
            if (driver?.name === dropDownValue) {
                setSelectedDriverName(driver.name);
                setSelectedDriverUid(driver.uid);
                return;
            }
        });
    }

    const handleSubmitButton = async () => {
        if (!emailRegex.test(email)) {
            showErrorToast("Please enter valid Email");
            return;
        }

        const selectedTime =
            (amPmText === "PM"
                ? parseInt(hour) === 12
                    ? hour
                    : (parseInt(hour) + 12).toString()
                : parseInt(hour) === 12
                    ? ((parseInt(hour) - 12).toString() + "0").toString()
                    : hour) +
            ":" +
            min +
            ":00";

        locationDetails.pickupTime = selectedTime;
        locationDetails.email = email;
        locationDetails.phoneNumber = phoneNumber;
        locationDetails.locationType = locationDetails.locationTypeCode; // locationTypeCode will go in locationType
        if (selectedDriverName.isNotEmpty) {
            locationDetails.assignedDriver = selectedDriverName;
        }

        try {
            if (isButtonEnabled) {
                setButtonEnabled(false);
                const response = await locationUpdateApiCall(locationDetails);
                if (response) {
                    if (selectedDriverUid && selectedDriverUid.trim() !== "") {
                        locationDetails.assignedDriverUid = selectedDriverUid;
                        if (locationDetails.locationTypeCode === "VL") {
                            try {
                                const response = await createDriverLocationMapping(
                                    locationDetails.locationId,
                                    selectedDriverUid
                                );
                                if (response) {
                                    showSuccessToast(
                                        `${locationDetails.locationName} details updated successfully`
                                    );
                                }
                            } catch (e) {
                                showErrorToast(
                                    `${locationDetails.locationName} details updated but driver mapping failed`
                                );
                            }
                        }
                    } else {
                        showSuccessToast(response.message);
                    }
                    handleCloseDialog(undefined, undefined, true);
                }
            }
        } catch (e) {
            handleCloseDialog(undefined, undefined, true);
            showErrorToast(`${locationDetails.locationName} details updated failed`);
        }
    };

    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            sx={{
                "& .MuiDialog-paper": {
                    width: "500px",
                },
            }}
        >
            <DialogTitle>
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    Edit Location
                    <div onClick={handleCloseDialog}>
                        <CloseIcon
                            style={{width: "24px", height: "24px", cursor: "pointer"}}
                        />
                    </div>
                </div>
            </DialogTitle>
            <DialogContent>
                <CommonPhoneNumberTextField
                    label="Phone Number"
                    inputValue={phoneNumber}
                    onHandleChange={handlePhoneNumberChange}
                    validator={phoneNumberValidation}
                    sx={{marginBottom: "15px"}}
                />

                <CommonEmailTextField
                    label="Email"
                    inputValue={email}
                    onHandleChange={handleEmailChange}
                    validator={emailValidation}
                    sx={{marginBottom: "15px"}}
                />

                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                color: "grey",
                                fontSize: "16px",
                            }}
                        >
                            <span style={{color: "red"}}>*</span>
                            <span>Time Of Visit</span>
                        </div>
                    </Grid>
                    {locationDetails?.locationTypeCode === "VL" && (
                        <Grid item xs={6}>
              <span
                  style={{paddingLeft: "40px", color: "grey", fontSize: "16px"}}
              >
                Driver
              </span>
                        </Grid>
                    )}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <CommonPhoneNumberTextField
                            label="Hour"
                            inputValue={hour}
                            onHandleChange={handleHourChange}
                            validator={validateHour}
                            maxLength={2}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <CommonPhoneNumberTextField
                            label="Minute"
                            inputValue={min}
                            onHandleChange={handleMinChange}
                            validator={validateMinute}
                            maxLength={2}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CommonEmailTextField
                            label=""
                            inputValue={amPmText}
                            otherProps={{readOnly: true}}
                            endAdornmentIcons={
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        onClick={handleArrowClick}
                                        style={{paddingTop: "20px", paddingRight: "5px"}}
                                    >
                                        <ArrowDropUp/>
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        onClick={handleArrowClick}
                                        style={{paddingBottom: "20px"}}
                                    >
                                        <ArrowDropDown/>
                                    </IconButton>
                                </div>
                            }
                        />
                    </Grid>

                    <Grid item xs={5}>
                        <DriverDropdown
                            warehouseLocationTypeCode={locationDetails?.locationTypeCode}
                            options={driverlist}
                            selectedValue={selectedDriverName}
                            onChange={handleDropdownChange}
                            sx={{
                                marginTop: "15px",
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <div style={{display: "flex", gap: "10px", marginRight: "10px"}}>
                    <button
                        style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                            height: 48,
                        }}
                        onClick={handleCloseDialog}
                    >
            <span style={{fontWeight: 600, fontSize: "14px", color: "black"}}>
              Cancel
            </span>
                    </button>

                    <FullButton
                        buttonText={"Submit"}
                        activeColor={CommonColorUtils.primaryMainBlue}
                        inactiveColor={CommonColorUtils.primaryMainBlueDisabledColor}
                        buttonTextColor={CommonColorUtils.primaryKWhite}
                        active={isButtonEnabled || false}
                        height={"48px"}
                        width={"100px"}
                        customCursor={isButtonEnabled ? "pointer" : "default"}
                        isDisable={!isButtonEnabled}
                        handleOnPress={() => handleSubmitButton()}
                    />
                </div>
            </DialogActions>
        </Dialog>
    );
}
